import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreSelectionDrawer, {
    ref: "selectionDrawerRef",
    attrs: {
      "has-search": "",
      "has-footer": "",
      "is-checked-variant": "",
      value: _setup.isVisibleModal,
      title: _setup.t(_setup.modalTitle, _setup.options),
      placeholder: _setup.t(_setup.modalPlaceholder, _setup.options),
      items: _setup.places,
      "selected-item": _setup.selectedPlace,
      error: _setup.isError,
      loading: _setup.isLoading,
      "is-back": _vm.isBack,
      attach: ".vue-the-lpu-filters .v-application",
    },
    on: {
      "click-item": _setup.onClickPlace,
      input: _setup.closeModal,
      back: _setup.closeModal,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "append-header",
          fn: function () {
            return [
              !_setup.isPlaceDefault
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-auto",
                      attrs: { color: "primary", small: "", text: "" },
                      on: { click: _setup.clickResetBtn },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.t("Сбросить", _setup.options)) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _vm._t(
                "footer",
                function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "pa-2 elevation-8" },
                      [
                        _c(
                          VBtn,
                          {
                            attrs: {
                              block: "",
                              depressed: "",
                              color: "primary",
                              disabled: !_setup.filtersStore.hasUnsavedFilters,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit(
                                  "place:selected",
                                  _setup.selectedPlace
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.t("Применить", _setup.options)) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                null,
                { selectedPlace: _setup.selectedPlace }
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }